<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import KastenLogo from '@/components/KastenLogo.vue';
import KLink from '@/components/KLink.vue';

const route = useRoute();
const isMCPage = computed(() => !!route.meta?.isMC);
</script>

<template>
  <div class="h-16 border-b border-gray-100 px-6 dark:border-navy-600">
    <KLink
      class="inline-flex h-16 shrink-0 items-center text-gray-600 focus-visible:outline-2 focus-visible:outline-blue-400 dark:text-gray-400"
      :to="isMCPage ? { name: 'MCClusters' } : { name: 'Dashboard' }"
    >
      <span class="sr-only">Veeam Kasten</span>
      <KastenLogo class="h-7" aria-hidden="true" />
    </KLink>
  </div>
</template>
